import React, { useContext, useState, useEffect, useRef } from "react";
import {
  Table,
  Label,
  Search,
  Modal,
  Tab,
  TabPane,
  Popup,
  Form,
} from "semantic-ui-react";
import { AppContext } from "../../Context/AppContext";
import { useHistory } from "react-router-dom";
import {
  deleteSchedulerOrder,
  getAllOrdersOfScheduler,
  getAllPostedOrdersOfScheduler,
  getSingleBuilding,
  orderDetailsGet,
  syncScheduler,
  sendRecommendedEmail,
  resendConfirmationEmail,
  downloadPestTracker,
} from "../../constants";
import "./cmp-scheduler-order-list.css";
import AppPagination from "../cmp-pagination/Pagination";
import { useLocation } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import MDL_PROGRESS from "../cmp-progress/cmp-progress";
import MDL_CHANGE_STATUS from "../../containers/scheduler/scheduler-home/mdl-change-status/mdl-change-status";
import moment from "moment";
import { isValid } from "date-fns";
import { useParams } from "react-router-dom";
import MDL_DELETE from "../cmp-delete-modal/cmp-delete-modal";
const SchedulerOrderList = ({ isImpersonated = false }) => {
  /* VARIABLE DECLARATIONS
	---------------------------------------------------------------------------------*/
  const {
    userInfo,
    selectedBuilding,
    selected_units,
    building_order_details,
    buildingUnits,
    sbuildingData,
    defaultPane,
    schedulerCheckOrderlist,
    error_validation,
    OrderTabStatus,
    refreshKey,
    appVersion,
    isAppVersionOutdated,
  } = useContext(AppContext);
  const [user] = userInfo;
  const [var_app_version] = appVersion;
  const [, set_is_app_version_outdated] = isAppVersionOutdated;
  const [, setBuildingUnits] = buildingUnits;
  const [, setFormError] = error_validation;
  const [, set_add_unit] = selected_units;
  const [, setSingleBuildingData] = sbuildingData;
  const [selected_building, setSelectedBuilding] = selectedBuilding;
  const [, setBuildingOrder] = building_order_details;
  const [orders, setOrders] = useState([]);
  const [postedOrders, setPostedOrders] = useState([]);
  const [recommendedFollowUpOrders, setRecommendedFollowUpOrders] = useState(
    [],
  );
  const [searchResult, setSearchResult] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [, setTotalOrders] = useState(0);
  const { addToast } = useToasts();
  const [var_mdl_progress, set_mdl_progress] = useState(false);
  const [selected_order, set_selected_order] = useState();
  const [var_default_pane, set_default_pane] = defaultPane;
  const [schedulerOrderlist] = schedulerCheckOrderlist;
  const [mdl_open_change_status, set_mdl_open_change_status] = useState(false);
  const [orderStatus, setOrderStatus] = OrderTabStatus;
  const [var_RefreshKey] = refreshKey;
  const [open_delete_modal, set_open_delete_modal] = useState(false);
  const [order_to_delete, set_order_to_delete] = useState(null);
  const [sortBy, setSortBy] = useState(3);
  const params = useParams();
  const location = useLocation();
  const isInitialMount = useRef(true);
  /* EVENT LISTENERS
	---------------------------------------------------------------------------------*/
  useEffect(() => {
    if (isInitialMount.current || var_default_pane !== 0) return;
    if (page > 1) {
      setPage(1);
    } else {
      if (var_default_pane === 0) {
        getSchedulerOrders(page, limit, searchValue, "", sortBy);
      }
    }
  }, [sortBy]);

  useEffect(() => {
    //getSchedulerOrders(page, limit,searchValue);
    if (var_default_pane === 0) {
      getSchedulerOrders(page, limit, searchValue, "", sortBy);
    }
    if (var_default_pane === 1) {
      getSchedulerOrders(page, limit, searchValue, "posted"); // Reset to page 1 or use `page`
    }
    if (var_default_pane === 2) {
      getSchedulerOrders(page, limit, searchValue, "followUp"); // Reset to page 1 or use `page`
    }
  }, [page, limit, window.location.pathname]);

  useEffect(() => {
    if (isInitialMount.current) return;
    /* 
    var_RefreshKey is to refresh the table after sync missing order.
    */
    setSearchValue("");
    setSearchResult([]);
    if (page > 1) {
      setPage(1);
    } else {
      if (var_default_pane === 0) {
        getSchedulerOrders(1, limit, "", "", sortBy);
      }
      if (var_default_pane === 1) {
        getSchedulerOrders(1, limit, "", "posted"); // Reset to page 1 or use `page`
      }
      if (var_default_pane === 2) {
        getSchedulerOrders(1, limit, "", "followUp"); // Reset to page 1 or use `page`
      }
    }
  }, [var_RefreshKey]);

  useEffect(() => {
    if (isInitialMount.current) return;
    //getSchedulerOrders(page, limit,searchValue);
    setPage(1);
    if (var_default_pane === 0 && orderStatus === "") {
      getSchedulerOrders(1, limit, searchValue, "", sortBy);
    }
    if (var_default_pane === 1 && orderStatus === "posted") {
      getSchedulerOrders(1, limit, searchValue, "posted"); // Reset to page 1 or use `page`
    }
    if (var_default_pane === 2 && orderStatus === "followUp") {
      getSchedulerOrders(1, limit, searchValue, "followUp"); // Reset to page 1 or use `page`
    }
  }, [schedulerOrderlist]);

  useEffect(() => {
    if (selected_order) onOpen_mdl_change_status(selected_order);
  }, [selected_order]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchValue) {
        if (var_default_pane === 0) {
          getSchedulerOrders(0, limit, searchValue, "", sortBy); // Reset to page 1 or use `page`
        }
        if (var_default_pane === 1) {
          getSchedulerOrders(0, limit, searchValue, "posted"); // Reset to page 1 or use `page`
        }
        if (var_default_pane === 2) {
          getSchedulerOrders(0, limit, searchValue, "followUp"); // Reset to page 1 or use `page`
        }
      }
    }, 1200);

    return () => clearTimeout(delayDebounceFn);
  }, [searchValue]);

  useEffect(() => {
    isInitialMount.current = false;
  }, []);

  /* ASYNC FUNCTIONS
	---------------------------------------------------------------------------------*/
  async function getSchedulerOrders(
    page_no,
    limit_range,
    q,
    order_status,
    sort_by,
  ) {
    var query_params = "";
    if (q) {
      query_params = `?q=${q}&page=${page_no ? page_no : 0}&limit=${
        limit_range ? limit_range : limit
      }&order_status=${order_status ? order_status : ""}&id=${user.uuid}`;
    } else {
      query_params = `?page=${page_no ? page_no : page}&limit=${
        limit_range ? limit_range : limit
      }&order_status=${order_status ? order_status : ""}&id=${user.uuid}`;
    }

    if (sort_by?.toString()) {
      query_params += `&sort_by=${sortBy}`;
    }

    if (isImpersonated) {
      query_params += `&buildingID=${params.building_id}`;
    }

    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    set_mdl_progress(true);
    if (order_status === "posted") {
      await fetch(getAllPostedOrdersOfScheduler + query_params, requestHeaders)
        .then((response) => response.json())
        .then((res) => {
          var ordersFetch = [];
          setTotalOrders(res?.body?.total_count);
          if (res.statusCode === 200) {
            ordersFetch = res.body.data;
            if (res.body.page_number > 1 && res && res && res?.length === 0) {
              setPage(res.body.page_number - 1);
            }
          } else {
            // Check app version
            if (res?.version && res?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
            ordersFetch = [];
          }
          if (page_no && page_no > 1) {
            ordersFetch = [...postedOrders, ...ordersFetch];
          } else {
            setPostedOrders([]);
          }
          setPostedOrders(ordersFetch);
          set_mdl_progress(false);
        })
        .catch((error) => {
          set_mdl_progress(false);
          console.error("Error:", error);
        });
    } else if (order_status === "followUp") {
      await fetch(getAllOrdersOfScheduler + query_params, requestHeaders)
        .then((response) => response.json())
        .then((res) => {
          var ordersFetch = [];
          setTotalOrders(res.body.total_count);
          if (res.statusCode === 200) {
            ordersFetch = res.body.data;
            if (res.body.page_number > 1 && res && res && res?.length === 0) {
              setPage(res.body.page_number - 1);
            }
          } else {
            // Check app version
            if (res?.version && res?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
            ordersFetch = [];
          }
          if (page_no && page_no > 1) {
            ordersFetch = [...recommendedFollowUpOrders, ...ordersFetch];
          } else {
            setRecommendedFollowUpOrders([]);
          }
          setRecommendedFollowUpOrders(ordersFetch);
          set_mdl_progress(false);
        })
        .catch((error) => {
          set_mdl_progress(false);
          console.error("Error:", error);
        });
    } else {
      await fetch(getAllOrdersOfScheduler + query_params, requestHeaders)
        .then((response) => response.json())
        .then((res) => {
          var ordersFetch = [];
          setTotalOrders(res.body.total_count);
          if (res.statusCode === 200) {
            ordersFetch = res.body.data;
            if (res.body.page_number > 1 && res && res && res?.length === 0) {
              setPage(res.body.page_number - 1);
            }
          } else {
            // Check app version
            if (res?.version && res?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
            ordersFetch = [];
          }
          if (page_no && page_no > 1) {
            ordersFetch = [...orders, ...ordersFetch];
          } else {
            setOrders([]);
          }
          setOrders(ordersFetch);
          set_mdl_progress(false);
        })
        .catch((error) => {
          set_mdl_progress(false);
          console.error("Error:", error);
        });
    }
  }

  async function goForEdit(id, isDraft) {
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    set_mdl_progress(true);
    await fetch(
      orderDetailsGet + "?id=" + id + "&unit_number=" + null,
      requestHeaders,
    )
      .then((resposnse) => resposnse.json())
      .then(async (res) => {
        if (res.code === 200) {
          //setData(res.data);
          await setSelectedBuilding({
            value: res.data.building_uuid,
            text: res.data.building_name,
            building_po_mo_wo: res.data.building_po_mo_wo,
          });

          var temp_units = [];
          var validation_error_temp = [];
          var canEdit = true;
          res.data.units?.map((vals_units, index) => {
            var temp = { ...vals_units };
            temp.key = index;
            if (temp.follow_up) {
              temp.followup = "followup";
            } else if (temp.isFollowupMonthly) {
              temp.followup = "followup_month";
            } else if (temp.isImmediate) {
              temp.followup = "followup_immediately";
            } else if (temp.is_reschedule) {
              temp.followup = "reschedule";
            } else {
              temp.followup = "neworder";
            }
            // if (temp.lineItemID?.length > 8) {
            //   canEdit = false;
            // }
            temp.pest = temp.pest_name;
            temp.treatment = temp.treatment_name;
            validation_error_temp = [...validation_error_temp, {}];
            temp_units.push(temp);
          });
          if (canEdit) {
            await set_add_unit(temp_units);
            await setBuildingOrder({
              building_name: res.data.building_name,
              po_mo_wo: res.data.building_po_mo_wo,
            });
            await fetch(
              getSingleBuilding + res.data.building_uuid,
              requestHeaders,
            )
              .then((response) => response.json())
              .then((response) => {
                const final_data = response.data[0];
                if (response.code !== 200) {
                  // Check app version
                  if (res?.version && response?.version !== var_app_version) {
                    set_is_app_version_outdated(true);
                  }
                }
                if (final_data) {
                  setSingleBuildingData(final_data);
                  setBuildingUnits(final_data.units ? final_data.units : []);
                }
              });
            setFormError(validation_error_temp);
            if (isDraft) {
              history.push({
                pathname: "/scheduler-order-draft",
                state: {
                  order_id: res.data.order_id,
                  building_code: res.data.location_id,
                  building_uuid: res.data.building_uuid,
                  building_name: res.data.building_name,
                  id: res.data.id,
                  isDraft: true,
                  from: location.pathname,
                },
              });
            } else {
              history.push({
                pathname: "/scheduler-home/update-order",
                state: {
                  order_id: res.data.order_id,
                  building_code: res.data.location_id,
                  building_uuid: res.data.building_uuid,
                  text: res.data.building_name,
                  building_po_mo_wo: res.data.building_po_mo_wo,
                  id: res.data.id,
                  from: location.pathname,
                },
              });
            }
          } else {
            addToast("You cannot edit this order.", {
              appearance: "error",
              autoDismiss: true,
            });
          }
        } else {
          // Check app version
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    set_mdl_progress(false);
  }

  async function doSearch(event) {
    const value = event.target.value.toString().toLowerCase();
    setPage(1);
    if (!value || value === "") {
      setSearchResult([]);
      setSearchValue("");
      if (var_default_pane === 0) {
        getSchedulerOrders(0, limit, value, "", sortBy); // Reset to page 1 or use `page`
      }
      if (var_default_pane === 1) {
        getSchedulerOrders(1, limit, value, "posted"); // Reset to page 1 or use `page`
      }
      if (var_default_pane === 2) {
        getSchedulerOrders(1, limit, value, "followUp"); // Reset to page 1 or use `page`
      }
    } else {
      setSearchValue(value);
    }
  }

  async function downloadReport() {
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    set_mdl_progress(true);
    try {
      await fetch(downloadPestTracker + selected_building, requestHeaders)
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            addToast(res.body.success, {
              appearance: "success",
              autoDismiss: true,
            });
          } else {
            if (res?.version && res?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
            addToast(res?.body?.error, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        });
    } catch (error) {
      console.error("Error:", error);
    }
    set_mdl_progress(false);
  }
  /* EVENT FUNCTIONS
	---------------------------------------------------------------------------------*/

  function goViewDetail(id, unit_number) {
    history.push({
      pathname: "/complete-order",
      state: { id, unit_number, from: location.pathname },
    });
  }

  function buildingSelect(uuid) {
    set_default_pane(0);
    history.push(`/building-impersonate/${uuid}`);
  }

  function AllOrdersCard({
    orders,
    searchResult,
    doSearch,
    limit,
    setLimit,
    page,
    setPage,
  }) {
    return (
      <>
        <div className="app-table-wrapper">
          <Table unstackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Order #</Table.HeaderCell>
                <Table.HeaderCell>Building</Table.HeaderCell>
                <Table.HeaderCell>Customer</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell>Confirmation Email</Table.HeaderCell>
                <Table.HeaderCell>Email Actions</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {searchResult.length === 0 &&
                orders &&
                orders.map((order, i) => (
                  <Table.Row key={i}>
                    <Table.Cell>{order.order_number}</Table.Cell>
                    <Table.Cell>
                      {isImpersonated ? (
                        order.building_name
                      ) : (
                        <span
                          className="building-link"
                          onClick={() => buildingSelect(order?.building_uuid)}
                        >
                          {order.building_name}
                        </span>
                      )}
                    </Table.Cell>

                    <Table.Cell>{order.customer_name} </Table.Cell>
                    {/* <Table.Cell>{order.customer_email}</Table.Cell> */}
                    <Table.Cell
                      className="td-status"
                      // onClick={() => {
                      //   onOpen_mdl_change_status(order);
                      // }}
                    >
                      {order.order_status === "posted" && (
                        <div style={{ color: "green" }}>Posted</div>
                      )}
                      {order.order_status === "completed" && (
                        <div style={{ color: "#05881F" }}>Completed</div>
                      )}
                      {order.order_status === "scheduled" && (
                        <div style={{ color: "#2196f3" }}>Scheduled</div>
                      )}
                      {order.order_status === "in progress" && (
                        <div style={{ color: "#FA8C16" }}>In Progress</div>
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      {
                        <div
                          style={{
                            color: order?.confirmationWorkDateTime
                              ? "#05881F"
                              : "red",
                          }}
                        >
                          {order?.confirmationWorkDateTime
                            ? moment(order?.confirmationWorkDateTime).format(
                                "MM-DD-YYYY hh:mm a",
                              )
                            : "Time Not Available"}
                        </div>
                      }
                    </Table.Cell>
                    <Table.Cell>
                      {order.order_status !== "completed" && (
                        <Label
                          color="orange"
                          className="resendBtn"
                          onClick={() => resendConfirmation(order.id)}
                        >
                          Resend
                        </Label>
                      )}
                    </Table.Cell>
                    <Table.Cell
                      className="td-action"
                      collapsing
                      textAlign="left"
                    >
                      <Label
                        color="green"
                        onClick={() => syncOrderList(order.id)}
                      >
                        Sync
                      </Label>
                      {order.order_status === "in progress" && (
                        <Label
                          color="blue"
                          onClick={() => goForEdit(order.id, false)}
                        >
                          Edit
                        </Label>
                      )}
                      {(order.order_status === "completed" ||
                        order.order_status === "scheduled" ||
                        order.order_status === "posted") && (
                        <Label
                          color="orange"
                          onClick={() => goViewDetail(order.id, null)}
                        >
                          View
                        </Label>
                      )}
                      <Label
                        color="red"
                        onClick={() => {
                          set_order_to_delete(order);
                          set_open_delete_modal(true);
                        }}
                      >
                        Delete
                      </Label>
                    </Table.Cell>
                  </Table.Row>
                ))}
              {searchResult.length > 0 &&
                searchResult.map((order, i) => (
                  <Table.Row key={i}>
                    <Table.Cell>{order.order_number}</Table.Cell>
                    {/* <Table.Cell>{order.unit_number}</Table.Cell> */}
                    <Table.Cell>{order.building_name}</Table.Cell>
                    <Table.Cell>{order.customer_name} </Table.Cell>
                    {/* <Table.Cell>{order.customer_email}</Table.Cell> */}
                    <Table.Cell
                      className="td-status"
                      // onClick={() => {
                      //   onOpen_mdl_change_status(order);
                      // }}
                    >
                      {order.order_status === "posted" && (
                        <div style={{ color: "green" }}>Posted</div>
                      )}
                      {order.order_status === "completed" && (
                        <div style={{ color: "#05881F" }}>Complete</div>
                      )}
                      {order.order_status === "scheduled" && (
                        <div style={{ color: "#05881F" }}>Scheduled</div>
                      )}
                      {order.order_status === "in progress" && (
                        <div style={{ color: "#FA8C16" }}>In Progress</div>
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      {order.confirmationEmailStatus ? (
                        // ||
                        // order.order_status === "completed"
                        <div
                          style={{
                            color: order?.confirmationWorkDateTime
                              ? "#05881F"
                              : "red",
                          }}
                        >
                          {order?.confirmationWorkDateTime
                            ? moment(order?.confirmationWorkDateTime).format(
                                "MM-DD-YYYY HH:mm a",
                              )
                            : "Time Not Available"}
                        </div>
                      ) : (
                        order.order_status !== "completed" && (
                          <Label
                            color="orange"
                            className="resendBtn"
                            onClick={() => resendConfirmation(order.id)}
                          >
                            Resend
                          </Label>
                        )
                      )}
                    </Table.Cell>
                    <Table.Cell
                      className="td-action"
                      collapsing
                      textAlign="left"
                    >
                      <Label
                        color="green"
                        onClick={() => syncOrderList(order.id)}
                      >
                        Sync
                      </Label>
                      {order.order_status === "in progress" && (
                        <Label
                          color="blue"
                          onClick={() => goForEdit(order.id, false)}
                        >
                          Edit
                        </Label>
                      )}
                      {order.order_status === "completed" ||
                        (order.order_status === "scheduled" && (
                          <Label
                            color="orange"
                            onClick={() => goViewDetail(order.id, null)}
                          >
                            View
                          </Label>
                        ))}
                      <Label
                        color="red"
                        onClick={() => deleteSchedulerOrderApiCall(order.id)}
                      >
                        Delete
                      </Label>
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </div>
        {orders.length === 0 && (
          <div className="nodata-placeholder">
            There is no order to display.
          </div>
        )}
        <AppPagination
          limit={limit}
          setLimit={setLimit}
          page={page}
          setPage={setPage}
          rowsTotal={orders.length}
        />
      </>
    );
  }

  function AllPostedOrdersCard({
    orders,
    searchResult,
    doSearch,
    limit,
    setLimit,
    page,
    setPage,
  }) {
    return (
      <>
        <div className="app-table-wrapper">
          <Table unstackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Batch #</Table.HeaderCell>
                <Table.HeaderCell>Batch Opened By</Table.HeaderCell>
                <Table.HeaderCell>Batch Opened On</Table.HeaderCell>
                <Table.HeaderCell>Order Count</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {searchResult.length === 0 &&
                orders &&
                orders.map((order, i) => (
                  <Table.Row key={i}>
                    <Table.Cell>{order.BatchNumber}</Table.Cell>
                    <Table.Cell>{order.batchOpenedBy}</Table.Cell>
                    <Table.Cell>
                      {moment(order.batchOpenedOn).format("MM-DD-YYYY hh:mm a")}
                    </Table.Cell>
                    <Table.Cell>{order.order_count}</Table.Cell>
                    <Table.Cell
                      className="td-action"
                      collapsing
                      textAlign="right"
                    >
                      <Label
                        color="green"
                        onClick={() => syncOrderList(order.BatchNumber)}
                      >
                        Sync
                      </Label>
                    </Table.Cell>
                  </Table.Row>
                ))}
              {searchResult.length > 0 &&
                searchResult.map((order, i) => (
                  <Table.Row key={i}>
                    <Table.Cell>{order.BatchNumber}</Table.Cell>
                    <Table.Cell>{order.batchOpenedBy}</Table.Cell>
                    <Table.Cell>
                      {moment(order.batchOpenedOn).format("MM-DD-YYYY hh:mm a")}
                    </Table.Cell>
                    <Table.Cell>{order.order_count}</Table.Cell>
                    <Table.Cell
                      className="td-action"
                      collapsing
                      textAlign="right"
                    >
                      <Label
                        color="green"
                        onClick={() => syncOrderList(order.BatchNumber)}
                      >
                        Sync
                      </Label>
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </div>
        {orders.length === 0 && (
          <div className="nodata-placeholder">
            There is no order to display.
          </div>
        )}
        <AppPagination
          limit={limit}
          setLimit={setLimit}
          page={page}
          setPage={setPage}
          rowsTotal={orders.length}
        />
      </>
    );
  }

  function RecommendedOrdersCard({
    orders,
    searchResult,
    doSearch,
    limit,
    setLimit,
    page,
    setPage,
  }) {
    return (
      <>
        <div className="app-table-wrapper">
          <Table unstackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Building</Table.HeaderCell>
                <Table.HeaderCell>Customer</Table.HeaderCell>
                <Table.HeaderCell>Units</Table.HeaderCell>
                <Table.HeaderCell>Treatment</Table.HeaderCell>
                <Table.HeaderCell>Recommended Date</Table.HeaderCell>
                <Table.HeaderCell>Note</Table.HeaderCell>
                <Table.HeaderCell>Email Actions</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {searchResult.length === 0 &&
                orders &&
                orders.map((order, i) => (
                  <Table.Row key={i}>
                    <Table.Cell>
                      {isImpersonated ? (
                        order.building_name
                      ) : (
                        <span
                          className="building-link"
                          onClick={() => buildingSelect(order?.building_uuid)}
                        >
                          {order.building_name}
                        </span>
                      )}
                    </Table.Cell>
                    <Table.Cell>{order.customer_name} </Table.Cell>
                    <Table.Cell>
                      {order?.units
                        ?.slice(0, 3)
                        .map((unit) => unit.unit_number)
                        .join(", ")}
                      {order?.units?.length > 3 ? "..." : ""}
                    </Table.Cell>
                    <Table.Cell>
                      {order?.units
                        ?.slice(0, 3)
                        .map((treatment) => treatment.treatment_name?.toLowerCase() === "activate treatment" ? "Activate (Actisol) Treatment" : treatment.treatment_name)
                        .join(", ")}
                      {order?.units?.length > 3 ? "..." : ""}
                    </Table.Cell>
                    <Table.Cell className="td-status">
                      {order.date && isValid(new Date(order.date))
                        ? moment(order.date).format("l")
                        : "N/A"}
                    </Table.Cell>
                    <Table.Cell>
                      {order?.units
                        ?.map((unit) => unit.note)
                        .filter((note) => note) // Remove empty notes
                        .slice(0, 3)
                        .join(", ")}
                      {order?.units
                        ?.map((unit) => unit.note)
                        .filter((note) => note).length > 3
                        ? "..."
                        : ""}
                    </Table.Cell>
                    <Table.Cell>
                      {order.order_status !== "completed" && (
                        <Label
                          color="orange"
                          className="resendBtn"
                          onClick={() =>
                            resendRecommendedConfirmation(order.id)
                          }
                        >
                          Resend
                        </Label>
                      )}
                    </Table.Cell>
                    <Table.Cell
                      className="td-action"
                      collapsing
                      textAlign="right"
                    >
                      <Label
                        color="green"
                        onClick={() => goForEdit(order.id, true)}
                      >
                        Edit
                      </Label>
                    </Table.Cell>
                  </Table.Row>
                ))}
              {searchResult.length > 0 &&
                searchResult.map((order, i) => (
                  <Table.Row key={i}>
                    <Table.Cell>
                      {order?.purchase_order_number || "N/A"}
                    </Table.Cell>
                    <Table.Cell>
                      {order?.units
                        ?.slice(0, 3)
                        .map((unit) => unit.unit_number)
                        .join(", ")}
                      {order?.units?.length > 3 ? "..." : ""}
                    </Table.Cell>
                    <Table.Cell>
                      {order?.units
                        ?.slice(0, 3)
                        .map((treatment) => treatment.treatment_name)
                        .join(", ")}
                      {order?.units?.length > 3 ? "..." : ""}
                    </Table.Cell>
                    <Table.Cell className="td-status">
                      {order.date && isValid(new Date(order.date))
                        ? moment(order.date).format("l")
                        : "N/A"}
                    </Table.Cell>
                    <Table.Cell>
                      {order?.units
                        ?.map((unit) => unit.note)
                        .filter((note) => note) // Remove empty notes
                        .slice(0, 3)
                        .join(", ")}
                      {order?.units
                        ?.map((unit) => unit.note)
                        .filter((note) => note).length > 3
                        ? "..."
                        : ""}
                    </Table.Cell>
                    {/* <Table.Cell
                        className="td-action"
                        collapsing
                        textAlign="right"
                      >
                        <Label
                            color="orange"
                            className="resendBtn"
                            onClick={() => resendConfirmation(order.id)}
                          >
                            Resend
                          </Label>
                        <Label
                          color="green"
                          onClick={() => goForEdit(order.id, null)}
                        >
                          Edit
                        </Label>
                      </Table.Cell> */}
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </div>
        {orders.length === 0 && (
          <div className="nodata-placeholder">
            There is no order to display.
          </div>
        )}
        <AppPagination
          limit={limit}
          setLimit={setLimit}
          page={page}
          setPage={setPage}
          rowsTotal={orders.length}
        />
      </>
    );
  }

  async function syncOrderList(id) {
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    set_mdl_progress(true);
    await fetch(syncScheduler + id, requestHeaders)
      .then((response) => response.json())
      .then((res) => {
        if (res.statusCode === 200) {
          setSearchValue("");
          addToast(res?.body?.success, {
            appearance: "success",
            autoDismiss: true,
          });
          if (var_default_pane === 0) {
            getSchedulerOrders(1, limit, "", "", sortBy);
          }
          if (var_default_pane === 1) {
            getSchedulerOrders(1, limit, "", "posted"); // Reset to page 1 or use `page`
          }
          if (var_default_pane === 2) {
            getSchedulerOrders(1, limit, "", "followUp"); // Reset to page 1 or use `page`
          }
        } else {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
          addToast(
            res?.body?.error ||
              res?.body?.message ||
              res.error?.message ||
              "There is some server side issue. Please try again later.",
            {
              appearance: "error",
              autoDismiss: true,
            },
          );
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    set_mdl_progress(false);
  }

  function deleteSchedulerOrderApiCall(service_id) {
    const requestOptionsOrder = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    fetch(deleteSchedulerOrder + service_id, requestOptionsOrder)
      .then((response) => response.json())
      .then((res) => {
        if (res.status === 200) {
          setSearchValue("");
          setSearchResult([]);
          if (page > 1) {
            setPage(1);
          } else {
            if (var_default_pane === 0) {
              getSchedulerOrders(1, limit, "", "", sortBy); // Reset to page 1 or use `page`
            }
            if (var_default_pane === 1) {
              getSchedulerOrders(1, limit, "", "posted"); // Reset to page 1 or use `page`
            }
            if (var_default_pane === 2) {
              getSchedulerOrders(1, limit, "", "followUp"); // Reset to page 1 or use `page`
            }
          }
        } else {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
        addToast(res.message, {
          appearance: res.status === 200 ? "success" : "error",
          autoDismiss: true,
        });
      })
      .catch((error) => {
        console.log("Error:::::", error);
      });
  }

  function resendConfirmation(service_id) {
    set_mdl_progress(true);
    const requestOptionsOrder = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    fetch(resendConfirmationEmail + service_id, requestOptionsOrder)
      .then((response) => response.json())
      .then((res) => {
        if (res.status === 200) {
          setSearchValue("");
          if (var_default_pane === 0) {
            getSchedulerOrders(page, limit, "", "", sortBy);
          }
          if (var_default_pane === 1) {
            getSchedulerOrders(page, limit, "", "posted"); // Reset to page 1 or use `page`
          }
          if (var_default_pane === 2) {
            getSchedulerOrders(page, limit, "", "followUp"); // Reset to page 1 or use `page`
          }
          setSearchResult([]);
        } else {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
        addToast(res.message, {
          appearance: res.status === 200 ? "success" : "warning",
          autoDismiss: true,
        });
        set_mdl_progress(false);
      })
      .catch((error) => {
        console.log("Error:::::", error);
        set_mdl_progress(false);
      });
  }

  function resendRecommendedConfirmation(service_id) {
    set_mdl_progress(true);
    const requestOptionsOrder = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    fetch(sendRecommendedEmail + service_id, requestOptionsOrder)
      .then((response) => response.json())
      .then((res) => {
        if (res.status === 200) {
          setSearchValue("");
          if (var_default_pane === 0) {
            getSchedulerOrders(page, limit, "", "", sortBy);
          }
          if (var_default_pane === 1) {
            getSchedulerOrders(page, limit, "", "posted"); // Reset to page 1 or use `page`
          }
          if (var_default_pane === 2) {
            getSchedulerOrders(page, limit, "", "followUp"); // Reset to page 1 or use `page`
          }
          setSearchResult([]);
        } else {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
        addToast(res.body.success, {
          appearance: res.statusCode === 200 ? "success" : "warning",
          autoDismiss: true,
        });
        set_mdl_progress(false);
      })
      .catch((error) => {
        console.log("Error:::::", error);
        set_mdl_progress(false);
      });
  }

  function handleClick() {
    history.push("/scheduler-order-draft");
    set_add_unit([{ unit_number: "", followup: "neworder", key: 0 }]);
  }

  function onOpen_mdl_change_status(order) {
    set_mdl_open_change_status(true);
    set_selected_order(order);
  }

  const panes = [
    {
      menuItem: {
        key: "allOrders",
        icon: "list alternate outline",
        content: "All Orders",
      },
      render: () => (
        <>
          <TabPane>
            <div className="app-card">
              <div className="app-card-header">
                <div className="app-card-title">
                  {`${isImpersonated ? "" : "Scheduler"} Orders List (${orders.length})`}
                  {isImpersonated && (
                    <Popup
                      content="Download Pest Tracker Report" // Text to show on hover
                      trigger={
                        <img
                          style={{ marginLeft: "5px", cursor: "pointer" }}
                          onClick={() => {
                            downloadReport();
                          }}
                          width="28"
                          height="25"
                          src={"/excel.png"}
                          alt="document"
                        />
                      }
                      position="top center" // Position of the tooltip
                    />
                  )}
                </div>
                <div
                  className="app-content-search"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    maxWidth: "700px",
                    gap: "16px",
                  }}
                >
                  <div style={{ flex: 3 }}>
                    <Search
                      placeholder={`${
                        location.pathname.includes("/scheduler-home")
                          ? "Search Building or Order #"
                          : "Search Order #"
                      }`}
                      onSearchChange={doSearch}
                      value={searchValue}
                      minCharacters={2}
                      showNoResults={false}
                    />
                  </div>

                  <div>
                    <Form.Select
                      className="sortby_optionss"
                      id="sortby_optionss"
                      name="sortby_optionss"
                      placeholder="Sort By"
                      label="Status: "
                      onChange={onChangeSortBy}
                      value={sortBy}
                      options={[
                        { key: 3, text: "All Orders", value: 3 },
                        { key: 0, text: "In Progress / Scheduled", value: 0 },
                        { key: 1, text: "Completed", value: 1 },
                      ]}
                    />
                  </div>
                </div>
              </div>
              <AllOrdersCard
                orders={orders}
                searchResult={searchResult}
                doSearch={doSearch}
                limit={limit}
                setLimit={setLimit}
                page={page}
                setPage={setPage}
              />
            </div>
          </TabPane>
        </>
      ),
    },
    {
      menuItem: {
        key: "posted",
        icon: "list alternate outline",
        content: "Posted",
      },
      render: () => (
        <TabPane>
          <div className="app-card">
            <div className="app-card-header">
              <div className="app-card-title">
                Posted Orders List ({postedOrders.length})
              </div>
              <div className="app-content-search">
                <Search
                  placeholder="Search Batch #"
                  onSearchChange={doSearch}
                  value={searchValue}
                  minCharacters={2}
                  showNoResults={false}
                />
              </div>
            </div>
            <AllPostedOrdersCard
              orders={postedOrders}
              searchResult={searchResult}
              doSearch={doSearch}
              limit={limit}
              setLimit={setLimit}
              page={page}
              setPage={setPage}
            />
          </div>
        </TabPane>
      ),
    },
    {
      menuItem: {
        key: "recommendedFollowUp",
        icon: "list alternate outline",
        content: "Recommended Follow-up",
      },
      render: () => (
        <TabPane>
          <div className="app-card">
            <div className="app-card-header">
              <div className="app-card-title">
                Recommended Orders List ({recommendedFollowUpOrders.length})
              </div>
              {location.pathname.includes("/scheduler-home") && (
                <div className="app-content-search">
                  <Search
                    placeholder="Search Building"
                    onSearchChange={doSearch}
                    value={searchValue}
                    minCharacters={2}
                    showNoResults={false}
                  />
                </div>
              )}
            </div>
            <RecommendedOrdersCard
              orders={recommendedFollowUpOrders}
              searchResult={searchResult}
              doSearch={doSearch}
              limit={limit}
              setLimit={setLimit}
              page={page}
              setPage={setPage}
            />
          </div>
        </TabPane>
      ),
    },
  ];

  const handleTabChange = (e, { activeIndex }) => {
    set_default_pane(activeIndex); // Update active tab
    setSearchValue("");
    setPage(1);
    setLimit(10);
    setSortBy(3);
    if (activeIndex === 0) {
      setOrderStatus("");
      getSchedulerOrders(1, 10, "", "", sortBy); // Reset to page 1 or use `page`
    }
    if (activeIndex === 1) {
      setOrderStatus("posted");
      getSchedulerOrders(1, 10, "", "posted"); // Reset to page 1 or use `page`
    }
    if (activeIndex === 2) {
      setOrderStatus("followUp");
      getSchedulerOrders(1, 10, "", "followUp"); // Reset to page 1 or use `page`
    }
  };

  function onChangeSortBy(event, { value }) {
    setSortBy(value);
  }

  /* RENDER APP
	---------------------------------------------------------------------------------*/

  return (
    <>
      <div>
        <Tab
          panes={panes}
          activeIndex={var_default_pane}
          onTabChange={handleTabChange}
        />

        {/***** MODAL: Status Change **************************************************************************/}
        <Modal
          id="mdl-change-status"
          dimmer={"inverted"}
          open={mdl_open_change_status}
          onClose={() => set_mdl_open_change_status(false)}
        >
          <MDL_CHANGE_STATUS
            set_mdl_Open={set_mdl_open_change_status}
            set_selected_order={set_selected_order}
            selected_order={selected_order}
            getSchedulerOrders={getSchedulerOrders}
          ></MDL_CHANGE_STATUS>
        </Modal>

        {/***** MODAL: PROGRESS **************************************************************************/}

        <Modal
          id="mdl-progress"
          dimmer={"inverted"}
          open={var_mdl_progress}
          closeOnDimmerClick={false}
          closeOnEscape={false}
          onClose={() => {}}
        >
          <MDL_PROGRESS
            set_mdl_open={set_mdl_progress}
            var_modaltitle="Please wait"
            var_message={"Please wait..."}
          ></MDL_PROGRESS>
        </Modal>

        {/***** END MODAL: PROGRESS **************************************************************************/}

        {/***** MODAL: MDL_DELETE **************************************************************************/}

        <Modal
          id="mdl-delete-confirmation"
          dimmer={"inverted"}
          size="tiny"
          open={open_delete_modal}
          onClose={() => {
            set_open_delete_modal(false);
          }}
        >
          <MDL_DELETE
            title={"Delete Order"}
            heading={
              order_to_delete?.order_number
                ? `Are you sure you want to delete Order #${order_to_delete.order_number}?`
                : "Are you sure you want to delete this order?"
            }
            message={"This action will remove the order from the system."}
            showPestPacWarning
            onCancel={() => set_open_delete_modal(false)}
            onSubmit={() => {
              deleteSchedulerOrderApiCall(order_to_delete.id);
            }}
          ></MDL_DELETE>
        </Modal>

        {/***** END MODAL: MDL_DELETE **************************************************************************/}
      </div>
    </>
  );
};

export default SchedulerOrderList;
